/*
 * match height
 */
jQuery(function($){
	for(var n = 1; n <= 10; n++){
		if ($('.match-height-' + n).length > 0){
			$('.match-height-' + n).matchHeight();
		}
	}
});